import axios from 'axios';
import { Message } from 'element-ui'; 
import loadingObj from '../utils/globalLoading';
import router from '../router';

const service  = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
    timeout: 3000000, // 设置请求超时时间
    // timeout: 30000, // 设置请求超时时间
})

// 请求拦截器
service.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token){
        config.headers.token = token;
    }
    loadingObj.showFullScreenLoading();
    // config.headers.Authorization = `Bearer ${token}`;
    return config
}, 
error =>{
     loadingObj.tryHideFullScreenLoading();
     Promise.reject(error)
}

    
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        const {code, data, message} = response.data;
        loadingObj.tryHideFullScreenLoading();
        if (code === 200) {
            return data
        } else {
            if(code === 400){
                localStorage.clear();
                router.push("/login")
                return 
            }
            // 提示错误信息
            Message({
                message: message || '请求失败',
                type: 'error',
                customClass: 'global-message-zindex'  // 添加自定义样式类
            });
            return Promise.reject(new Error(message))
        }
    },
    error => {
        loadingObj.tryHideFullScreenLoading();
         // 处理 HTTP 错误（如 401 跳转登录）
        if (error.response?.status === 400) { // code = 400 没token
            Message({
                message: '登录已过期',
                type: 'error',
                customClass: 'global-message-zindex'  // 添加自定义样式类
            });
            router.push('/login');
        }
        return Promise.reject(error);
    }
)

export default service
